export const licenseKeys = {
  all: ["license"] as const,
  check: () => [...licenseKeys.all, "check"] as const,
  state: () => [...licenseKeys.all, "state"] as const,
};
